// Plain ESM with no bundler-only imports, so the post-build SEO step can read
// these same values from Node instead of keeping a second copy of them.

export const GAME_NAME = 'Warm';
export const STUDIO_NAME = 'OutHereGaming LLC';
export const STUDIO_SHORT_NAME = 'OutHereGaming';
export const TAGLINE = 'Keep the fire alive. Last the night.';
export const CONTACT_EMAIL = 'dev@outheregaming.com';

// The canonical host. Everything else 301s here, so all absolute URLs in
// metadata, the sitemap, and structured data have to agree with it.
export const SITE_URL = 'https://www.outheregaming.com';

// Steam app 3813060 is the Warm store page. Swap in a playtest or demo URL here
// if the store listing moves; every Steam call to action reads from this value.
export const STEAM_APP_ID = '3813060';
export const STEAM_URL = `https://store.steampowered.com/app/${STEAM_APP_ID}/`;

// Rendered in the footer and published as the studio's sameAs links in the
// structured data, which is how a search engine ties these profiles to the site.
// The label keys the icon in components/icons.js, so add one there to match.
export const SOCIAL_LINKS = [
  { label: 'YouTube', url: 'https://www.youtube.com/@outheregames' },
  { label: 'Instagram', url: 'https://www.instagram.com/outheregames' },
  { label: 'TikTok', url: 'https://www.tiktok.com/@warmonsteam' },
  { label: 'X', url: 'https://x.com/ohgdev' },
];

export const TWITTER_HANDLE = '@ohgdev';

// Google Analytics 4 measurement ID. Public by design — it identifies the
// property, it does not grant access to it. Analytics only run on the canonical
// host, so local development and previews stay out of the reporting.
export const GA_MEASUREMENT_ID = 'G-QKYHJZBT7G';
